import { GetApp } from '@mui/icons-material';
import { GridCsvExportMenuItem, GridToolbarExportContainer } from '@mui/x-data-grid-pro';
import { exportStyles } from '../../utils/export';
import ExcelExportMenuOption from '../atoms/export/ExcelExportMenuOption';
import PrintExportMenuOption from '../atoms/export/PrintExportMenuOption';
import StyledIcon from '../atoms/StyledIcon';
import { Tooltip } from '@mui/material';

const CustomToolbar = (showSearch: boolean, showCustomizeTable: boolean, exportAllColumns = false) => {
  return (
    <Tooltip placement='top-start' title='Export'>
      <GridToolbarExportContainer
        slotProps={{
          button: {
            material: {
              variant: 'text',
              sx: (theme) => exportStyles(theme, showSearch, showCustomizeTable),
              startIcon: <StyledIcon Icon={GetApp} />,
            },
          },
        }}
      >
        <GridCsvExportMenuItem options={{ allColumns: exportAllColumns }} />
        <PrintExportMenuOption options={{ allColumns: exportAllColumns }} />
        <ExcelExportMenuOption allColumns={exportAllColumns} />
      </GridToolbarExportContainer>
    </Tooltip>
  );
};

export default CustomToolbar;
